import { useTranslation } from 'react-i18next';

import { Alert } from '@/shared/ui/atoms';

import type { BannerPortugueseGap } from '../../../types/bannerForm';

export interface BannerPortugueseFirstAlertProps {
  /** Lacunas do cadastro em português — o alerta não aparece com a lista vazia. */
  readonly gaps: readonly BannerPortugueseGap[];
}

/**
 * Aviso de que o cadastro em Português (BR) precisa vir antes das traduções.
 *
 * O app cai no conteúdo em português quando o idioma do aluno não tem tradução,
 * então um banner traduzido sem título ou sem mídia em português sairia vazio
 * para todo mundo. O texto nomeia o que falta, para o operador saber onde voltar.
 */
export function BannerPortugueseFirstAlert({ gaps }: BannerPortugueseFirstAlertProps) {
  const { t } = useTranslation('banner');

  if (gaps.length === 0) return null;

  const missing =
    gaps.length > 1
      ? t('banner.form.language.portugueseFirst.gapBoth')
      : gaps[0] === 'media'
        ? t('banner.form.language.portugueseFirst.gapMedia')
        : t('banner.form.language.portugueseFirst.gapTitle');

  return (
    <Alert
      type="warning"
      title={t('banner.form.language.portugueseFirst.title')}
      description={t('banner.form.language.portugueseFirst.body', { missing })}
    />
  );
}
